export interface InventoryMeasurementFormData {
  items: {
    material_name: string;
    adjusted_quantity?: number;
    adjusted_yard_quantity?: number;
    adjusted_railcar_quantity?: number;
  }[];
}

export enum InventoryMeasurementFormState {
  Pending,
  Submitting,
  Submitted,
}

export interface InventoryMeasurementSubmittedItem {
  material_name: string;
  quantity_scrap_bay: number;
  quantity_yard: number;
  quantity_rail_car: number;
  price: number;
  total: number;
}

export interface DeliveryMeasurementSubmittedItem {
  material_name: string;
  quantity: number;
}
